import React from "react";

const mainHeader = () => (
  <div>
    <div className="intro-lead-in">Intelligent, Interactive Technologies</div>
    <div className="heading text-uppercase">in VR & Data Analytics</div>
    <a
      className="btn btn-primary btn-xl text-uppercase js-scroll-trigger"
      href="#tech"
    >
      Tell Me More
    </a>
  </div>
);

export default mainHeader;
